import Api from './ApiRequest';

export const LocationTypeApi = {
    getAll: () => Api.get('/cent/location/types')
};
export const LocationStatusApi = {
    getAll: () => Api.get('/cent/location/statuses')
};